function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "acc-path-1",
  points: "0.578468348 0.134705646 14.5106114 0.134705646 14.5106114 19 0.578468348 19"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "acc-path-3",
  points: "0.2372 0 5.6562 0 5.6562 5.4199 0.2372 5.4199"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.7861,22.2519 C4.8861,22.2519 2.5191,19.8859 2.5191,16.9849 C2.5191,15.6109 3.0921,14.3129 3.9701,13.3589 L3.0921,10.8019 C1.2211,12.2139 0.0001,14.4659 0.0001,16.9469 C0.0001,21.2209 3.4731,24.6949 7.7481,24.6949 C9.8861,24.6949 11.8321,23.8169 13.2441,22.4049 L12.3661,19.4279 C11.5651,21.1069 9.8091,22.2519 7.7861,22.2519",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "#acc-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#acc-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.1835,9.0761 C11.9925,8.4281 11.3815,7.9701 10.6945,7.9701 L7.6795,7.9701 L7.2215,5.7181 L10.8475,5.7181 C11.5345,5.7181 12.1065,5.1451 12.1065,4.4581 C12.1065,3.7711 11.5345,3.1991 10.8475,3.1991 L6.7255,3.1991 L6.6105,2.7021 C6.4195,1.7101 5.7325,0.7561 4.7785,0.3741 C3.4425,-0.1979 1.9545,0.2981 1.1525,1.4051 C0.5795,2.2061 0.4275,3.2371 0.7325,4.1531 L2.6795,9.9921 C2.9085,10.6031 3.4815,11.0611 4.1295,11.0611 L9.5115,11.0611 L11.4965,17.8931 C11.6875,18.5801 12.2975,19.0001 12.9845,19.0001 C13.2135,19.0001 13.4815,18.9621 13.7095,18.8091 C14.3585,18.4661 14.6635,17.6641 14.4355,16.9391 L12.1835,9.0761 Z",
  fill: "#FEFEFE",
  mask: "url(#acc-mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "#acc-mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#acc-path-3"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.9462,-0.0001 C4.4432,-0.0001 5.6562,1.2129 5.6562,2.7099 C5.6562,4.2069 4.4432,5.4199 2.9462,5.4199 C1.4502,5.4199 0.2372,4.2069 0.2372,2.7099 C0.2372,1.2129 1.4502,-0.0001 2.9462,-0.0001",
  fill: "#FEFEFE",
  mask: "url(#acc-mask-4)"
}))));

var SvgAccessibility = function SvgAccessibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccessibility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accessibility.c678b3df.svg";
export { ForwardRef as ReactComponent };